import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet marker icon issue
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const Map: React.FC = () => {
  const locations = [
    {
      name: 'Ubud',
      position: [-8.505814, 115.262249],
      image: '/images/ubud/photo28.jpg',
      description: '⭐ Mount Batur ⭐',
    },
    {
      name: 'Canggu',
      position: [-8.661099, 115.132674],
      image: '/images/canggu/photo15.jpg',
      description: '⭐ Sunset at La brisa ⭐',
    },
    {
      name: 'Uluwatu',
      position: [-8.825843, 115.105631],
      image: '/images/uluwatu/photo14.jpg',
      description: '⭐ Surfing ⭐',
    },
    {
      name: 'Nusa Lembongan',
      position: [-8.678698, 115.455605],
      image: '/images/nusa lembongan/photo7.jpg',
      description: '⭐ Devils Tears ⭐',
    },
    {
      name: 'Gili Air',
      position: [-8.358527, 116.081744],
      image: '/images/gili air/photo8.jpg',
      description: '⭐ Snorkeling ⭐',
    },
    {
      name: 'Kuala Lumpur',
      position: [3.128561, 101.707927],
      image: '/images/kuala lumpur/photo17.jpg',
      description: '⭐ Petronas Twin Towers ⭐',
    },
    {
      name: 'George Town',
      position: [5.409812, 100.324729],
      image: '/images/george town/photo23.jpg',
      description: '⭐ Penang Hill ⭐',
    },
    {
      name: 'Langkawi',
      position: [6.362032, 99.806771],
      image: '/images/langkawi/photo30.jpg',
      description: '⭐ Beach Fire Shows ⭐',
    },
    {
      name: 'Da Nang',
      position: [16.048863, 108.213192],
      image: '/images/da nang/photo8.jpg',
      description: '⭐ Monkey Mountain ⭐',
    },
    {
      name: 'Hoi An',
      position: [15.879028, 108.328460],
      image: '/images/hoi an/photo32.jpg',
      description: '⭐ Ba Na Hills ⭐',
    }
  ];

  return (
    <div style={{ width: '100%', height: '60vh', margin: 'auto' }}>
      <MapContainer center={[10, 105]} zoom={4} style={{ width: '100%', height: '100%' }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {locations.map((loc) => (
          <Marker key={loc.name} position={loc.position}>
            <Popup>
              <div style={{ textAlign: 'center' }}>
                <img
                  src={loc.image}
                  alt={loc.name}
                  style={{
                    width: '72px',
                    height: '72px',
                    objectFit: 'cover',
                    borderRadius: '10px',
                    marginBottom: '6px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  }}
                />
                <h3>{loc.name}</h3>
                <p>{loc.description}</p>
                <a
                  href={`/location/${loc.name.toLowerCase()}`}
                  style={{
                    display: 'inline-block',
                    padding: '6px 12px',
                    backgroundColor: '#007bff',
                    color: '#fff',
                    borderRadius: '4px',
                    textDecoration: 'none',
                  }}
                >
                  View Gallery
                </a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default Map;